import { useMemo } from 'react'

import { useUnitTypeLabel } from '../../../../../../hooks/remainingBudgetHooks'
import { useFetchLineItemForecast } from './useFetchLineItemForecast'
import { useDebounce } from '../../../../../../../../../../../hooks/useDebounce'

export const useLineItemForecastData = ({ values, inventory, microAmount, units, targetingEnabled = true }) => {
  // Debounce units value to prevent too frequent API calls when user is typing
  // and avoid unnecessary network requests
  const debouncedUnits = useDebounce(units, 300)

  const unitTypeLabel = useUnitTypeLabel()

  const { data } = useFetchLineItemForecast({
    values,
    inventory,
    microAmount,
    units: debouncedUnits
  })

  const forecastData = useMemo(() => {
    const matchedUnits = data?.matched_units
    const inputUnitsNumber = parseFloat(debouncedUnits) || 0
    const shouldShowForecastWarning = matchedUnits && inputUnitsNumber > 0 && matchedUnits < inputUnitsNumber

    const forecastErrorMessage = targetingEnabled
      ? `This placement is predicted to deliver ${matchedUnits} ${unitTypeLabel.toLowerCase()} for your selected campaign dates and targeting. This will likely underdeliver.`
      : `This placement is predicted to deliver ${matchedUnits} ${unitTypeLabel.toLowerCase()} for your selected campaign dates. This will likely underdeliver.`

    return {
      forecastErrorMessage: shouldShowForecastWarning ? forecastErrorMessage : null
    }
  }, [data, debouncedUnits, unitTypeLabel, targetingEnabled])

  return forecastData
}
